var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-screen"},[_c('InlineLoader'),_c('div',{staticClass:"captcha-container"},[(_vm.$route.name === 'DemoPresentation')?_c('guest-recaptcha',{ref:"recaptcha",on:{"success":_vm.onRecaptchaSuccess,"error":_vm.onRecaptchaError,"offline":_vm.onOffline}}):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }